<script>
export default {
  data: () => ({
    observer: null,
  }),
  mounted() {
    const options = this.options || {};
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit("intersect");
      }
    }, options);

    this.observer.observe(this.$el);
  },
  destroyed() {
    this.observer.disconnect();
  }
};
</script>
<template>
    <div class="autoscroll"></div>
</template>
<style scoped>
  .autoscroll {
    position: absolute;
    bottom: 0px;
    height: 300px;
    width: 1px;
    /* background: pink; */
  }
</style>